import { render, staticRenderFns } from "./channel_pop.vue?vue&type=template&id=0bfa346c&scoped=true"
import script from "./channel_pop.vue?vue&type=script&lang=js"
export * from "./channel_pop.vue?vue&type=script&lang=js"
import style0 from "./channel_pop.vue?vue&type=style&index=0&id=0bfa346c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfa346c",
  null
  
)

export default component.exports